"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAddressSearch = void 0;
var _react = require("react");
var _useQuestionSelectionActions = require("./useQuestionSelectionActions");
var _productCatalogSelectors = require("../../store/productCatalog/productCatalogSelectors");
var _services = require("../../services");
var _utils = require("../../utils/utils");
var _constants = require("../../utils/constants");
var _productCatalogActions = require("../../store/productCatalog/productCatalogActions");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
const useAddressSearch = (question, selections) => {
  const minCharacters = question.minCharacters;
  const selection = selections[0] || '';
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const [address, setAddress] = (0, _react.useState)(selection ? JSON.parse(selection).name : '');
  const [streetNumber, setStreetNumber] = (0, _react.useState)(selection ? JSON.parse(selection).selectedStreetNr : '');
  const addresses = (0, _useAppSelector.useAppSelector)(_productCatalogSelectors.selectAddressSuggestions);
  const addressSuggestions = addresses.map(el => ({
    text: el.name
  }));
  const {
    replaceSelection,
    removeSelection
  } = (0, _useQuestionSelectionActions.useQuestionSelectionActions)(question);
  (0, _react.useEffect)(() => {
    //if address is one of the suggestions from the api and the street number is an integer make the selection
    if (!!addressSuggestions.find(suggestion => suggestion.text === address) && streetNumber) {
      replaceSelection(createSelection());
    }
  }, [address, streetNumber]);
  const onChange = value => {
    setAddress(value);
    if (selection && value !== address) {
      removeSelection(selection);
    }
  };
  const createSelection = function () {
    let {
      addressSelection,
      numberSelection
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const addressObject = addresses.find(addressObject => {
      return addressObject.name === addressSelection ? addressSelection : address;
    });
    return JSON.stringify({
      ...addressObject,
      selectedStreetNr: numberSelection ? numberSelection : streetNumber
    });
  };
  const onStreetNumberChange = value => {
    setStreetNumber(value);
    if (selection && !value) {
      removeSelection(selection);
    }
  };
  const onSelect = choice => {
    if (choice.hasEmptyResults) return;
    setAddress(choice.text);
  };
  const onFilter = async value => {
    let broadbandAddresses = [];
    try {
      broadbandAddresses = await getBroadbandAddresses(value.trim());
    } catch (error) {
      console.log('Error: Getting BroadbandAddresses');
    }
    const suggestedBroadbandAddresses = broadbandAddresses.map(el => ({
      text: el.name
    }));
    return suggestedBroadbandAddresses.length ? suggestedBroadbandAddresses : [{
      text: _services.locale.localeString('ErrorPage.AddressNotFound', {
        value: value
      }),
      hasEmptyResults: true
    }];
  };
  const getBroadbandAddresses = async address => {
    try {
      const url = `${_constants.API_PATH.ADDRESS_FINDER}/geographicAddress?addressKeyword=${address}`;
      const response = await _services.http.get(url);
      const addresses = response.map(address => {
        const addressWithNoStreetNumber = (0, _utils.clone)(address);
        delete addressWithNoStreetNumber.streetNr;
        return addressWithNoStreetNumber;
      });
      dispatch({
        type: _productCatalogActions.FETCH_BROADBAND_ADDRESSES_SUCCESS,
        payload: {
          addresses: addresses
        }
      });
      return addresses;
    } catch (error) {
      dispatch({
        type: _productCatalogActions.FETCH_BROADBAND_ADDRESSES_ERROR
      });
    }
  };
  return {
    addressSuggestions,
    address,
    minCharacters,
    onChange,
    onStreetNumberChange,
    onSelect,
    onFilter,
    streetNumber
  };
};
exports.useAddressSearch = useAddressSearch;